/* Falcon product gallery: thumbnails under the main slider, "How to order" video popup,
   and a sticky media column that never hides its own bottom on tall layouts. */
(function () {
  function thumbSrc(src) {
    if (!src) return '';
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=200');
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=200';
  }

  function initThumbs(root) {
    if (root.dataset.ready) return;
    var slider = document.getElementById('FalconSlider-' + root.dataset.sectionId);
    if (!slider) return;
    root.dataset.ready = 'true';

    var slides = [];
    Array.prototype.forEach.call(slider.children, function (el) {
      if (el.classList.contains('falcon-slide') && el.querySelector('img')) slides.push(el);
    });
    if (slides.length < 2) return;

    var track = root.querySelector('.falcon-gthumbs__track');
    var buttons = slides.map(function (slide, i) {
      var img = slide.querySelector('img');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'falcon-gthumbs__item';
      btn.setAttribute('aria-label', 'Show image ' + (i + 1));
      var t = document.createElement('img');
      t.src = thumbSrc(img.getAttribute('src'));
      t.alt = '';
      t.loading = 'lazy';
      t.width = 200;
      t.height = 200;
      btn.appendChild(t);
      btn.addEventListener('click', function () {
        var delta = slide.getBoundingClientRect().left - slider.getBoundingClientRect().left;
        slider.scrollTo({ left: slider.scrollLeft + delta, behavior: 'smooth' });
        setActive(i);
      });
      track.appendChild(btn);
      return btn;
    });
    root.hidden = false;

    var current = -1;
    function setActive(i) {
      if (i === current || !buttons[i]) return;
      if (buttons[current]) {
        buttons[current].classList.remove('is-active');
        buttons[current].removeAttribute('aria-current');
      }
      current = i;
      buttons[i].classList.add('is-active');
      buttons[i].setAttribute('aria-current', 'true');
      var b = buttons[i];
      var target = b.offsetLeft - (track.clientWidth - b.offsetWidth) / 2;
      track.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    }

    function syncFromSlider() {
      var sliderLeft = slider.getBoundingClientRect().left;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function (slide, i) {
        var d = Math.abs(slide.getBoundingClientRect().left - sliderLeft);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      setActive(best);
    }

    var ticking = false;
    slider.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; syncFromSlider(); });
    }, { passive: true });

    syncFromSlider();
  }

  /* "How to order" pill on the main image: opens the same YouTube video in a popup. */
  var modal;
  function embedUrl(id) {
    return 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
  }
  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modal.querySelector('.falcon-howto-modal__frame').innerHTML = '';
    document.documentElement.style.overflow = '';
    if (modal._opener) modal._opener.focus();
  }
  function openModal(id, title, opener) {
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'falcon-howto-modal';
      modal.hidden = true;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.innerHTML =
        '<div class="falcon-howto-modal__backdrop"></div>' +
        '<div class="falcon-howto-modal__dialog">' +
        '<button type="button" class="falcon-howto-modal__close" aria-label="Close video">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
        '</button><div class="falcon-howto-modal__frame"></div></div>';
      document.body.appendChild(modal);
      modal.querySelector('.falcon-howto-modal__backdrop').addEventListener('click', closeModal);
      modal.querySelector('.falcon-howto-modal__close').addEventListener('click', closeModal);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    }
    var iframe = document.createElement('iframe');
    iframe.src = embedUrl(id);
    iframe.title = title || 'How to order';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    modal.querySelector('.falcon-howto-modal__frame').appendChild(iframe);
    modal.setAttribute('aria-label', iframe.title);
    modal._opener = opener;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    modal.querySelector('.falcon-howto-modal__close').focus();
  }
  function initHowTo(root) {
    var column = root.closest('.falcon-media-column');
    var card = column && column.querySelector('.falcon-media-card');
    if (!card || card.querySelector('.falcon-howto-btn')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'falcon-howto-btn';
    btn.innerHTML =
      '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="12" fill="#ef6533"/><path d="M10 8l6 4-6 4z" fill="#fff"/></svg>' +
      '<span></span>';
    btn.querySelector('span').textContent = root.dataset.howtoLabel || 'How to order';
    btn.addEventListener('click', function () { openModal(root.dataset.videoId, root.dataset.title, btn); });
    card.appendChild(btn);
  }

  /* A sticky column taller than the viewport would keep its bottom (thumbnails, video)
     permanently off-screen, so pin it by its bottom edge instead. */
  var stickyCols = [];
  function fitSticky(col) {
    col.style.top = '';
    if (getComputedStyle(col).position !== 'sticky') return;
    var baseTop = parseFloat(getComputedStyle(col).top) || 0;
    var overflow = col.offsetHeight + baseTop + 20 - window.innerHeight;
    if (overflow > 0) col.style.top = (baseTop - overflow) + 'px';
  }
  function trackSticky(col) {
    if (!col || stickyCols.indexOf(col) > -1) return;
    stickyCols.push(col);
    fitSticky(col);
    if ('ResizeObserver' in window) new ResizeObserver(function () { fitSticky(col); }).observe(col);
  }
  window.addEventListener('resize', function () { stickyCols.forEach(fitSticky); });

  function init() {
    document.querySelectorAll('[data-falcon-gthumbs]').forEach(function (root) {
      initThumbs(root);
      trackSticky(root.closest('.falcon-media-column'));
    });
    document.querySelectorAll('[data-falcon-pvideo]').forEach(function (root) {
      initHowTo(root);
      trackSticky(root.closest('.falcon-media-column'));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
